import { Shared } from 'types/Shared'

type State = {
  shared: Shared
}

export const getShared = (state: State): Shared => state.shared || {}
